import { render } from "./Donate.vue?vue&type=template&id=6dbca0ec&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=6dbca0ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dbca0ec"

export default script